import { useEffect } from 'react';
import Lenis from 'lenis';

// Shared helpers for lab pages (Velora lab-kit convention).

export const clamp01 = (v) => Math.min(1, Math.max(0, v));
export const seg = (p, a, b) => clamp01((p - a) / (b - a));
export const ease = (t) => t * t * (3 - 2 * t); // smoothstep
export const lerp = (a, b, t) => a + (b - a) * t;

// Premium smooth scrolling for lab pages. No-op when disabled (reduced motion).
export const useLenis = (enabled) => {
  useEffect(() => {
    if (!enabled) return undefined;
    const lenis = new Lenis({ lerp: 0.12, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, [enabled]);
};
